import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import ArrowBackRounded from '@material-ui/icons/ArrowBackRounded';

import Component from '../../ui-components/Component';
import { withTranslations, withResizer, withUser } from '../../HoCs';
import Page from '../../ui-components/Page';
import Styles from './styles';
import { isEmptyObject, merge } from '../../utils';
import { columnCenter, blackHigh } from '../../resources/styles';
import IconButton from '../../ui-components/Button/Icon';
import { path } from '../../utils';
import view from '../../Enums';

import { forceLogout } from '../../services/Network';
import { Link } from 'react-router-dom';
import pages, { getRouteForPage } from '../../PageEnums';
import CyclicFooter from '../../ui-components/Banners/CyclicFooter';
import { hmsSelfOnboardingEnabled } from '../../config/countryConfig';


class Profile extends Component {
    
    styles = Styles;
    translation_key = 'profile_translations';
    
    onSignoutClick = () => forceLogout();
    
    componentDidMount() {
        hmsSelfOnboardingEnabled() ? forceLogout() :
        window.addEventListener('unload', () => console.log('unload handler'));
    }
    
    
    render = () => <Page title={this.gc('my_profile')}
                         contentStyle={merge(columnCenter, (this.getViewMode() == view.DESKTOP ? {} : {
                             padding: '24px',
                             paddingBottom: '30px'
                         }))} renderFooter={() => <CyclicFooter style={this.gs('footer')}/>}>
        
        <div style={this.gs('header')}>
            <Link to={getRouteForPage(pages.PROPERTIES)}><IconButton><ArrowBackRounded style={blackHigh}/></IconButton></Link>
            <div style={this.gs('header_title')}>{this.gc('my_profile')}</div>
        </div>
        
        <div style={this.gs('card_container')}>
            <div style={this.gs('card')}>
                <div style={this.gs('title')}>
                    {this.gc('NAME')}
                </div>
                <div style={this.gs('value')}>
                    {this.getUserName()}
                </div>
            </div>
            
            <div style={this.gs('card')}>
                <div style={this.gs('title')}>
                    {this.gc('phone_number')}
                </div>
                <div style={this.gs('value')}>
                    {this.getPhone()}
                </div>
            </div>
            
            <div style={this.gs('card')}>
                <div style={this.gs('title')}>
                    {this.gc('EMAIL')}
                </div>
                <div style={this.gs('value')}>
                    {this.getEmail()}
                </div>
            </div>
            
            <div style={{ ...this.gs('card'), borderBottom: 'none' }}>
                <div style={this.gs('title')}>
                    {this.gc('PASSWORD')}
                </div>
                <div style={merge(this.gs('value'), { color: 'var(--theme-color)' })}>
                    *******
                </div>
            </div>
        
        
        </div>
        
        <ButtonBase style={this.gs('signout_ripple')} onClick={this.onSignoutClick}>
            <div style={this.gs('signout_button')}>{this.guc('sign_out')}</div>
        </ButtonBase>
    
    </Page>;
}

export default withUser(withTranslations(withResizer(Profile)));
